

























import { Component, Mixins } from 'vue-property-decorator';
import propsMixin from '../propsMixim';

@Component
export default class CalendarIcon extends Mixins(propsMixin) {
  get style() {
    const { bgColor, active } = this;
    if (active) return '#FFF';
    return bgColor ? `#${bgColor}` : '#000';
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/calendar/components/selector/components/icons/CalendarIcon.vue